import { c as _c } from "react/compiler-runtime";
import { IcoSpeedometer24 } from '@onefootprint/icons';
import type { FakeImageScore } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import type { TransformedDocument } from '@/components/entities/components/details/hooks/use-documents';
import useDocumentUploadSideText from '@/entity/hooks/use-document-upload-side-text';
import CollapsibleSection from '../collapsible-section';
type AiImageScoresProps = {
  uploads: TransformedDocument['uploads'];
};
const AiImageScores = t0 => {
  const $0 = _c(28);
  const {
    uploads
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents.details.aiImageScores"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const sideT = useDocumentUploadSideText();
  let T0;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($0[1] !== sideT || $0[2] !== t || $0[3] !== uploads) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const scoredUploads = uploads.filter(_temp).map(_temp2).filter(_temp3);
      let t8;
      if ($0[11] !== t) {
        t8 = t9 => {
          const {
            score,
            verdict
          } = t9;
          return {
            score: Math.round(score * 100),
            verdict: t($ => $.verdict[verdict])
          };
        };
        $0[11] = t;
        $0[12] = t8;
      } else {
        t8 = $0[12];
      }
      const format = t8;
      if (scoredUploads.length === 0) {
        t7 = null;
        break bb0;
      }
      T0 = CollapsibleSection;
      t4 = IcoSpeedometer24;
      if ($0[13] !== t) {
        t5 = t(_temp4);
        $0[13] = t;
        $0[14] = t5;
      } else {
        t5 = $0[14];
      }
      t6 = true;
      t2 = "flex flex-col gap-2 w-full";
      let t9;
      if ($0[15] !== format || $0[16] !== sideT || $0[17] !== t) {
        t9 = t10 => {
          const {
            side: side_0,
            openai: openai_0,
            jev: jev_0
          } = t10;
          return <div key={side_0} className="flex justify-between gap-3"><span className="text-label-2 text-primary">{sideT(side_0)}</span><div className="flex gap-3 text-body-2 text-secondary">{openai_0 && <span>{t(_temp5, format(openai_0))}</span>}{jev_0 && <span>{t(_temp6, format(jev_0))}</span>}</div></div>;
        };
        $0[15] = format;
        $0[16] = sideT;
        $0[17] = t;
        $0[18] = t9;
      } else {
        t9 = $0[18];
      }
      t3 = scoredUploads.map(t9);
    }
    $0[1] = sideT;
    $0[2] = t;
    $0[3] = uploads;
    $0[4] = T0;
    $0[5] = t2;
    $0[6] = t3;
    $0[7] = t4;
    $0[8] = t5;
    $0[9] = t6;
    $0[10] = t7;
  } else {
    T0 = $0[4];
    t2 = $0[5];
    t3 = $0[6];
    t4 = $0[7];
    t5 = $0[8];
    t6 = $0[9];
    t7 = $0[10];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  let t8;
  if ($0[19] !== t2 || $0[20] !== t3) {
    t8 = <div className={t2}>{t3}</div>;
    $0[19] = t2;
    $0[20] = t3;
    $0[21] = t8;
  } else {
    t8 = $0[21];
  }
  let t9;
  if ($0[22] !== T0 || $0[23] !== t4 || $0[24] !== t5 || $0[25] !== t6 || $0[26] !== t8) {
    t9 = <T0 icon={t4} title={t5} defaultOpen={t6}>{t8}</T0>;
    $0[22] = T0;
    $0[23] = t4;
    $0[24] = t5;
    $0[25] = t6;
    $0[26] = t8;
    $0[27] = t9;
  } else {
    t9 = $0[27];
  }
  return t9;
};
export default AiImageScores;
function _temp(t0) {
  const {
    isLatest
  } = t0;
  return isLatest;
}
function _temp2(t0) {
  const {
    side,
    experiment
  } = t0;
  return {
    side,
    ...experiment?.aiImageScore
  };
}
function _temp3(t0) {
  const {
    openai,
    jev
  } = t0;
  return openai || jev;
}
function _temp4($_0) {
  return $_0.title;
}
function _temp5($_1) {
  return $_1.openai;
}
function _temp6($_2) {
  return $_2.jev;
}